import { LoadState } from "../../constants/enums";

export interface ISignature {
  signature_code: string;
  signature_name: string;
  html_content: string;
  is_default: number;
  status: string;
  create_ts: string;
}

export interface ISignatureState {
  list: ISignature[];
  loading: LoadState;
  allSignatures: ISignature[];
  allSignaturesLoading: LoadState;
}

export const initialSignatureState: ISignatureState = {
  list: [],
  loading: LoadState.NotLoaded,
  allSignatures: [],
  allSignaturesLoading: LoadState.NotLoaded,
};

export const initialSignature: ISignature = {
  signature_code: "",
  signature_name: "",
  html_content: "",
  is_default: 0,
  status: "ACTIVE",
  create_ts: "",
};
